const ViewSessionsConstants = {
  SET_VISIBLE_RANGE: 'VIEWSESSIONS_SET_VISIBLE_RANGE',
  REFRESH: 'VIEWSESSIONS_REFRESH',
  GET: 'VIEWSESSIONS_GET',
  GET_SUCCESS: 'VIEWSESSIONS_GET_SUCCESS',
  GET_FAIL: 'VIEWSESSIONS_GET_FAIL',
  RELOAD: 'VIEWSESSIONS_RELOAD',
  SET_FILTER: 'VIEWSESSIONS_SET_FILTER',
  ACTIVATE_FILTER: 'VIEWSESSIONS_ACTIVATE_FILTER',
  SET_ADVANCED_FILTER: 'VIEWSESSIONS_SET_ADVANCED_FILTER',
  SET_SORTORDER: 'VIEWSESSIONS_SET_SORTORDER',
  MODIFY_SELECTION: 'VIEWSESSIONS_MODIFY_SELECTION',
  ALLOW_MULTI_SELECT: 'VIEWSESSIONS_ALLOW_MULTI_SELECT',
  REMOVE_SUCCESS: 'VIEWSESSIONS_REMOVE_SUCCESS',
  SAVE_SUCCESS: 'VIEWSESSIONS_SAVE_SUCCESS',
  ENSURE_SELECTION_IS_VISIBLE: 'VIEWSESSIONS_ENSURE_SELECTION_IS_VISIBLE',
  CLEAR: 'VIEWSESSIONS_CLEAR',
  UPDATE: 'VIEWSESSIONS_UPDATE',
  SET_SELECTION: 'VIEWSESSIONS_SET_SELECTION',
  OPEN: 'VIEWSESSIONS_OPEN',
  GET_FOR_OPEN_SUCCESS: 'VIEWSESSIONS_GET_FOR_OPEN_SUCCESS',
  GET_BY_ID_SUCCESS: 'VIEWSESSIONS_GET_BY_ID_SUCCESS',
  FIND_SUCCESS: 'VIEWSESSIONS_FIND_SUCCESS',

  UPDATE_MAXSESSIONS: 'VIEWSESSIONS_UPDATE_MAXSESSIONS'
};

export default ViewSessionsConstants;